import CustomTooltip from '@/components/ToolTip/CustomTooltip';
import { IVoice, Providers } from '@d-id/types';
import styled from '@emotion/styled';
import { Player } from '@lottiefiles/react-lottie-player';
import { useMemo, useState } from 'react';
import Stopwatch from './images/Stopwatch.svg';
import StopwatchAnimation from './images/StopwatchAnimation.json';

const StopwatchIcon = styled.img`
    display: flex;
    height: 2rem;
    width: 2rem;
`;

const StopWatchPlayer = styled(Player)`
    height: 2rem;
    width: 2rem;
`;

const AddBreakButton = styled.button`
    display: flex;
    margin-left: 10px;
    align-items: center;
    cursor: pointer;
    background: transparent;
    border: none;
    font-size: 1.33333rem;
    font-weight: 400;
    line-height: 100%;
    color: #000000de;
    padding: 0;

    :disabled {
        cursor: default;
        color: #9a9a9a;
    }
`;

const StyledCustomTooltip = styled(CustomTooltip)`
    position: absolute;
    top: -36px;
    z-index: 1;
    width: unset;
`;

interface Props {
    voice: IVoice | null;
    onClick: () => void;
}

export const AddBreak = ({ voice, onClick }: Props) => {
    const [isAnimated, setIsAnimated] = useState(false);
    const validVoice = voice?.provider !== Providers.Amazon;

    const tooltipText = useMemo(() => {
        if (!validVoice) {
            return "Breaks aren't available for this voice";
        }

        return 'Add a 0.5s break';
    }, [validVoice]);

    return (
        <StyledCustomTooltip title={tooltipText} placement="top" containerHeight="2rem" cursor="pointer" disabled={!validVoice}>
            <AddBreakButton
                id="break"
                onClick={(event: React.MouseEvent) => {
                    event.preventDefault();
                    onClick();
                }}>
                {isAnimated ? (
                    <StopWatchPlayer src={StopwatchAnimation} autoplay onEvent={event => event === 'complete' && setIsAnimated(false)} />
                ) : (
                    <StopwatchIcon src={Stopwatch} />
                )}
            </AddBreakButton>
        </StyledCustomTooltip>
    );
};
